import grey from '@material-ui/core/colors/grey';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { showroomImageLabelHeight } from '../Content/MediaItem/styles';

export type ShowroomMediaActionsStylesProps = {
	displayLabel: boolean;
};

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		wrapper: {
			position: 'relative',
			width: '100%',
			height: (props: ShowroomMediaActionsStylesProps) => (props.displayLabel ? `calc(100% - ${showroomImageLabelHeight}px)` : '100%'),
			pointerEvents: 'all'
		},
		mediaActionsWrapper: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			zIndex: 10,
			padding: 10,
			cursor: 'pointer',
			pointerEvents: 'none',
			WebkitTapHighlightColor: 'transparent'
		},
		mediaActionsWrapperMobile: {
			padding: '5px 5px'
		},
		mediaActionsInnerWrapper: {
			width: '100%',
			height: '100%',
			position: 'relative',
			overflow: 'hidden'
		},
		mediaActionsContainer: {
			position: 'absolute',
			right: -60,
			padding: 5,
			height: (props: ShowroomMediaActionsStylesProps) => (props.displayLabel ? `calc(100% - ${showroomImageLabelHeight}px)` : '100%'),
			display: 'flex',
			alignItems: 'flex-start',
			transition: 'all 0.2s'
		},
		actionButton: {
			padding: 0,

			'&:hover': {
				background: 'none'
			}
		},
		actionButtonIcon: {
			color: grey[500]
		},
		actionButtonDownloadIcon: {
			'&:hover': {
				color: theme.palette.primary.main
			}
		},
		actionButtonDownloadIconActive: {
			color: theme.palette.primary.main
		},
		mediaActionsContainerVisible: {
			right: 0
		},
		actionsMenuDesktop: {
			display: 'flex',
			flexDirection: 'column',
			padding: '15px 5px',
			width: 30,
			alignItems: 'center',
			borderRadius: 100,
			pointerEvents: 'all',
			background: 'white',
			boxShadow: theme.custom.defaultBoxShadow
		},
		actionsMenuDivider: {
			marginTop: 15,
			marginBottom: 15,
			width: 18
		},
		actionsMobileButton: {
			pointerEvents: 'all',
			padding: 6
		},
		actionsMobileIcon: {
			color: 'white',
			fontSize: 23
		},
		zoomButtonContainer: {
			position: 'absolute',
			bottom: -50,
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
			pointerEvents: 'none',
			transition: 'all 0.2s'
		},
		zoomButtonContainerDisplayed: {
			bottom: 0
		},
		zoomButton: {
			pointerEvents: 'all',
			background: 'black !important'
		},
		zoomButtonLabel: {
			color: 'white',
			fontSize: 24
		},
		singleDownloadMenuPaper: {
			borderRadius: 4
		},
		singleDownloadMenuList: {
			minWidth: 220
		},
		singleDownloadMenuItem: {
			fontSize: 14,
			padding: '15px 30px'
		},
		singleDownloadMenuDivider: {
			marginLeft: 30,
			marginRight: 30
		},
		tooltip: {
			backgroundColor: grey[700],
			color: 'white',
			padding: 10,
			fontSize: 12,
			zIndex: 2000,
			borderRadius: 3,

			'&[x-placement*="right"]': {
				left: '15px !important'
			},
			'&[x-placement*="left"]': {
				left: '-15px !important'
			}
		},
		loader: {
			color: grey[500]
		}
	};
});
